var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123.24 125.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16486",
    d: "m60.33,48.23c-1.57,0-2.84,1.27-2.84,2.84,0,1.57,1.27,2.84,2.84,2.84,1.57,0,2.84-1.27,2.84-2.84,0-1.57-1.27-2.84-2.84-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16487",
    d: "m91.53,68.44c-5.47,0-9.91,4.44-9.91,9.91,0,5.47,4.44,9.91,9.91,9.91,5.47,0,9.91-4.44,9.91-9.91,0-5.47-4.44-9.91-9.91-9.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16488",
    d: "m30.88,53.9c1.57,0,2.84-1.27,2.84-2.84s-1.27-2.84-2.84-2.84-2.84,1.27-2.84,2.84c0,1.57,1.27,2.84,2.84,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16489",
    d: "m106.5,9.38h-6.81v17.85c0,2.78-2.26,5.04-5.04,5.04s-5.04-2.26-5.04-5.04V9.38h-55.58v17.85c0,2.78-2.26,5.04-5.04,5.04-2.78,0-5.04-2.26-5.04-5.04h0V9.38h-7.21C7.5,9.38,0,16.88,0,26.12v82.27c0,9.24,7.5,16.73,16.74,16.74h89.76c9.24-.01,16.73-7.5,16.74-16.74V26.12c0-9.24-7.5-16.73-16.74-16.74m-14.97,83.93s-.08,0-.12,0c-4.07,10.12-12.97,16.59-23.05,16.59-13.26,0-24.17-11.41-25.18-25.86-11.47-1.26-20.15-10.93-20.17-22.47v-10.49c-.01-4.36,3.51-7.91,7.88-7.92,4.36-.01,7.91,3.51,7.92,7.88.01,4.36-3.51,7.91-7.88,7.92-.99,0-1.96-.18-2.88-.54v3.15c.07,9.7,8,17.51,17.7,17.43,9.6-.07,17.36-7.83,17.43-17.43v-3.15c-4.06,1.56-8.61-.46-10.18-4.51-1.56-4.06.46-8.61,4.51-10.18s8.61.46,10.18,4.51c.35.9.53,1.87.53,2.84v10.49c-.02,11.47-8.6,21.11-19.99,22.45.97,11.68,9.63,20.85,20.13,20.85,7.68,0,14.53-4.84,17.98-12.5-7.71-2.89-11.62-11.49-8.73-19.2,2.89-7.71,11.49-11.62,19.2-8.73,7.71,2.89,11.62,11.49,8.73,19.2-2.19,5.83-7.77,9.69-14,9.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16490",
    d: "m94.65,0c-1.39,0-2.52,1.13-2.52,2.52v24.71c0,1.39,1.13,2.52,2.52,2.52s2.52-1.13,2.52-2.52V2.52C97.17,1.13,96.04,0,94.65,0c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16491",
    d: "m28.99,0c-1.39,0-2.52,1.13-2.52,2.52v24.71c0,1.39,1.13,2.52,2.52,2.52s2.52-1.13,2.52-2.52V2.52C31.51,1.13,30.38,0,28.99,0c0,0,0,0,0,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsa);
export default __webpack_public_path__ + "static/media/JSA.730f280e30706d39e84e36b4d61bb99e.svg";
export { ForwardRef as ReactComponent };